// extracted by mini-css-extract-plugin
export default {"root":"LoginForm_root__N+AS2","form":"LoginForm_form__QiWrV","button":"LoginForm_button__ln-i2"};